import { useTranslation } from "react-i18next";
import vconst from "utils/helpers/structs/vconst";

const OperationWarehouse = ({operation}) => {
    const { t } = useTranslation(['Warehouses']);

    const wpartner = operation?.wpartner;
    const wpartnerId = Number(operation?.wpartnerId || 0);
    const isMain = wpartnerId === vconst.waherouseMainId;
    const isWriteOff = wpartnerId === vconst.waherouseWriteOffId;
    const isCustom = Number(wpartner?.customId) > 0;
    const isTeam = Number(wpartner?.teamId) > 0;
    const isReserve = Number(wpartner?.reservObjectId) > 0;
    const isObject = Number(wpartner?.objectId) > 0 && !isReserve;
    const isMissingPartner = !wpartner && !isMain && !isWriteOff;

    return (<>

        {/** Склад відсутній */}
        {isMissingPartner && (
            <span className="text-warning fw-medium">{t('noWarehouse')}</span>)}

        {/** Основний склад */}
        {isMain && (<>
            <span className="text-info fw-medium">{t('mainWarehouse')}</span></>)}

        {/** Склад списання */}
        {isWriteOff && (<>
            <span className="text-danger fw-medium">{t('writeOffWarehouse')}</span></>)}

        {/** Користувацький склад */}
        {isCustom && (<>
            <span className="text-info fw-medium">
                {wpartner?.customName || `#${wpartner?.customId}`}
            </span>
            <span className="d-block fs-12 text-muted">{t('customWarehouse')}</span></>)}

        {/** Склад Бригади */}
        {isTeam && (<>
            <span className="text-primary fw-medium"
                title={wpartner?.clientName}>
                {wpartner?.teamName}</span>
            <span className="d-block fs-12 text-muted">{t('teamWarehouse')}</span></>)}

        {/** Склад резерву */}
        {isReserve && (<>
            <span className="text-warning fw-medium"
                title={wpartner?.clientName}>
                {wpartner?.objectName || wpartner?.clientName}</span>
            <span className="d-block fs-12 text-muted">{t('reserveWarehouse')}</span></>)}

        {/** Склад Обєкта */}
        {isObject && (<>
            <span className="text-success fw-medium"
                title={wpartner?.clientName}>
                {wpartner?.objectName || wpartner?.clientName}</span>
            <span className="d-block fs-12 text-muted">{wpartner?.clientName}</span></>)}

    </>)
}

export default OperationWarehouse;
